import { createForm } from '../../../factories'

export default createForm(['email', 'password', 'token'])



// WEBPACK FOOTER //
// ./src/store/modules/register/forms/resetPassword.js